//swiper
import "swiper/css";
import "swiper/css/bundle";
import "swiper/css/pagination";
import "swiper/css/autoplay";

import ReactDOM from "react-dom/client";
import "./App.scss";
import App from "App";
import "i18";
import { SnackbarProvider } from "notistack";

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement,
);
root.render(
	<SnackbarProvider>
		<App/>
	</SnackbarProvider>
);